export default __webpack_public_path__ + "static/media/cookImg.9a4d19a0.png";